module.exports = __webpack_public_path__ + "static/media/OurProduct-YellowCircle.3b4d8151.svg";